import { render, staticRenderFns } from "./ColoroverviewPage.vue?vue&type=template&id=bab30194"
import script from "./ColoroverviewPage.vue?vue&type=script&lang=js"
export * from "./ColoroverviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports